export const BUY_NOW_LINK_VARIATION_B =
    'https://www.hp.com/es-es/shop/list.aspx?fc_sb_smarttank=1&sel=prn&utm_source=Platinum&utm_medium=B2&utm_campaign=Referral';

export const BUY_NOW_LINK_VARIATION_D_SAYAN =
    'https://www.hp.com/es-es/shop/list.aspx?fc_sb_smarttank=1&sel=prn&utm_source=Platinum&utm_medium=D1&utm_campaign=Referral';

export const BUY_NOW_LINK_VARIATION_D_LEBI =
    'https://www.hp.com/es-es/shop/list.aspx?fc_sb_smarttank=1&sel=prn&utm_source=Platinum&utm_medium=D2&utm_campaign=Referral';
